module.exports = __webpack_public_path__ + "img/tg-icon.8fafacd2.svg";